import { Col, Form, Label, Row } from "reactstrap"
import {
  DebounceInputSearch,
  UFDate,
  UFInput,
} from "../../../components/Common/Fields/Input"
import resetIcon from "../../../assets/icons/reset.svg"
import { useForm } from "react-hook-form"
import { useEffect, useRef } from "react"
import moment from "moment"
import { isEmpty } from "lodash"
import VoucherTypes from "../../../components/Common/chooseFields/voucherTypes"
import FinanceGroupType from "../../../components/Common/chooseFields/financeGroupType"

const GroupSummaryFilter = ({
  handleSearchChange,
  handleDateChange,
  handleAccChange,
  handleVoucherTypeChange,
  isGroup,
  resetData,
}) => {
  const {accData, fromDate, toData, search} = resetData || {};
  const { control, watch, reset, setValue } = useForm()
  const initialSearchSetRef = useRef(false)
  const handleReset = () => {
    handleDateChange("")
    handleSearchChange("")
    handleAccChange("")
    handleVoucherTypeChange()
    reset({
      // search: "",
      account_code: null,
      start_date: "",
      end_date: "",
      // voucher_type: null,
    })
  }
  useEffect(() => {
    handleSearchChange(watch("search"))
  }, [watch("search")])

  const handleRequestdate = () => {
    const startDate = watch("start_date")
    const endDate = watch("end_date")
    const formattedStart = startDate
      ? moment(startDate).format("YYYY-MM-DD")
      : ""
    const formattedEnd = endDate ? moment(endDate).format("YYYY-MM-DD") : ""
    handleDateChange(formattedStart, formattedEnd)
  }

  const handleAccno = data => {
    handleAccChange(data)
  }

  const handleVoucherType = data => {
    handleVoucherTypeChange(data?.value)
  }

  useEffect(() => {
           setValue(
             "account_code",
             accData
               ? { label: accData.label, value: accData.value }
               : null,
             { shouldValidate: false, shouldDirty: false }
           )
           setValue(
             "start_date",
             fromDate
               ? moment(fromDate, "YYYY-MM-DD").toDate()
               : null,
             { shouldValidate: false, shouldDirty: false }
           )
           setValue(
             "end_date",
             toData
               ? moment(toData, "YYYY-MM-DD").toDate()
               : null,
             { shouldValidate: false, shouldDirty: false }
           )
           // set initial search from prop only once (don't overwrite while user types)
           if (search && !initialSearchSetRef.current) {
             setValue("search", search, { shouldValidate: false, shouldDirty: false })
             initialSearchSetRef.current = true
           }
        }, [fromDate, toData, accData, setValue, search])

  return (
    <>
      <div className="d-flex justify-content-between align-items-center my-2 me-2">
        <Form id="user-form" className="filter-wrapper">
          <Row className="mx-0">
            {isGroup && (
              <Col sm={2} className="pe-1">
                <FinanceGroupType
                  control={control}
                  name={"account_code"}
                  placeholder={"Group"}
                  target={"body"}
                  fromFilter={true}
                  onSelectChange={e => handleAccno(e)}
                />
              </Col>
            )}
            <Col sm={2} className="pe-1">
              <UFDate
                control={control}
                name={"start_date"}
                placeholder={"Start Date"}
                onDateChange={handleRequestdate}
              />
            </Col>
            <Col sm={2} className="pe-1">
              <UFDate
                control={control}
                name={"end_date"}
                placeholder={"End Date"}
                onDateChange={handleRequestdate}
              />
            </Col>
            {/* <Col sm={2} className="pe-1">
              <VoucherTypes
                control={control}
                name={"voucher_type"}
                placeholder={"Voucher Type"}
                onSelectChange={e => handleVoucherType(e)}
                clearable={true}
              />
            </Col> */}
          </Row>
        </Form>
        <div className="d-flex">
          {/* <Col
            lg={"auto"}
            onClick={() => handleFinacialCheck(finacialCheck)}
            className=" d-flex align-items-center"
          >
            <input
              type="checkbox"
              className="ever-rise-checkbox"
              name={"is_finacial_year"}
              checked={finacialCheck}
            />
            <Label className="ms-2 mb-0">
              FY {loggedUser?.finance?.replace(/\//g, "")}
            </Label>
          </Col> */}
          <div
            className="export-div pointer me-2 reset-img py-1"
            onClick={() => handleReset()}
          >
            <img src={resetIcon} height={15} width={15} className="me-2" />{" "}
            Reset
          </div>
          {/* <DebounceInputSearch
            control={control}
            placeholder={"Search"}
            name={"search"}
            className={"search-input"}
            minLength={1}
            debounceTimeout={700}
          /> */}
          {/* <UFInput
            control={control}
            placeholder="Search"
            name={"search"}
            className={"search-input"}
          /> */}
          {/* <div className="export-div pointer" onClick={() => toggle()}>
            <img src={exportIcon} />
          </div> */}
        </div>
      </div>
    </>
  )
}

export default GroupSummaryFilter
